export const apiConfig = {
    "property": {
        "getPropertyDetailsByRequestId": "/get_properties",
        "getPropertyDetailsByPropertyId": "/get_property_details",
        "getPropertyQuickDetailsByPropertyId": "/get_property_quick_details",
        "updateProperty": "/update_property",
    },
    "transaction": {
        "getTransactionDetailsByRequestId": "/get_transaction",
        "getTransactionDetailsByTransactionId": "/get_transaction_details",
        "updateTransaction": "/update_transaction",
    },
    "requestTable": {
        "updateRequest": "/update-request",
    },
    "clientCounterparty": {
        "getEntityByRequestId": "/get_entity",
        "getDeligenceType": "/get_deligence_type",
        "getEntityDetailsByEntityId": "/get_entity_details",
        "getQuickEntityDetailsByEntityId": "/get_quick_entity_details",
        "addEntity": "/add_entity"
    },
    "corporateStructure": {
        "saveCorporateStructure": "/save_corporate_structure",
        "getCorporateStructure": "/get_corporate_structure",
        "getquickCorporateStructure": "/get_quick_corporate_structure"
    },
    "managementStructure": {
        "saveManagementStructure": "/save-management-data",
        "getManagementStructure": "/get-management-data",
        "getQuickManagementStructure": "/get-quick-management-data"
        
    },
    "CODAdmin": {
        "addUserFromCOD": "/add_user_from_cod",
        "addCustomer": "/add_customer",
        "getSubscriptionPlans": "/get_subscription_plans",
        "getCountriesWithPagination": "/get_country_Cod",        
        "updateTable": "/Change_Required_Table"
    },
    "sendMail": "/send_mail",
    "update_diligence": "/update_deligence_status"
}